import client from '@/lib/api/client'
import type { HelpdeskRequest } from '@/types/helpdesk'

export type GetHelpdeskRequestsParams = {
  q?: string
  from?: string // ISO
  to?: string // ISO
  status?: 'NEW' | 'ACKNOWLEDGED'
  page?: number
  pageSize?: number
  sort?: 'recent' | 'oldest'
}

// NOTE: Replace endpoints when backend confirms routes.
export async function getHelpdeskRequests(_params: GetHelpdeskRequestsParams): Promise<HelpdeskRequest[]> {
  // Temporary: return empty (UI uses mock hook)
  return []
}

export async function acknowledgeHelpdeskRequest(id: string): Promise<void> {
  void id
}